import * as Yup from 'yup';
import { Select } from 'app/shared/inputs/Select';
import { IQueueConfiguration } from './types';

export const addNewSubgroupValidationSchema = Yup.object().shape({
  name: Yup.string().min(1).max(128).required(),
  paramsType: Yup.string().required(),
});

export const queueConfigurationValidationSchema = Yup.object().shape({
  group: Yup.string().required(),
  subgroup: Yup.string().required(),
  paramsType: Yup.string().required(),
  menuWorkflows: Yup.object().nullable(),
  hasMyContacts: Yup.boolean().nullable(),
  hasMyTeamContacts: Yup.boolean().nullable(),
  hasMyDeals: Yup.boolean().nullable(),
  hasMyTeamDeals: Yup.boolean().nullable(),
  hasRedDeals: Yup.boolean().nullable(),
  hasAmberDeals: Yup.boolean().nullable(),
  hasGreenDeals: Yup.boolean().nullable(),
  hasRedContacts: Yup.boolean().nullable(),
  hasAmberContacts: Yup.boolean().nullable(),
  hasGreenContacts: Yup.boolean().nullable(),
  isUnAssigned: Yup.boolean().nullable(),
  hasDeals: Yup.string().nullable(),
  hasActiveDeal: Yup.string().nullable(),
  unAssignedTag: Yup.string().nullable(),
  excludedLenderIds: Yup.object().nullable(),
  isDealActive: Yup.string().nullable(),
  assetSelected: Yup.string().nullable(),
  isHotTitles: Yup.boolean().nullable(),
  isAcceleratedTitleSupported: Yup.boolean().nullable(),
  acceleratedTitleTitleIsReleasable: Yup.boolean().nullable(),
  isQueueEnabled: Yup.boolean().nullable(),
  checkRequestStatus: Yup.string().nullable(),
  isQueueEmailRequired: Yup.boolean(),
  queueEmailRoles: Yup.array().when('isQueueEmailRequired', {
    is: true,
    then: Yup.array().min(1, 'Must be filled!'),
  }),
  description: Yup.string().nullable(),
  roleId: Yup.string().nullable(),
  isCountRequired: Yup.boolean().nullable(),
  isDownPaymentDeclineQueue: Yup.boolean().nullable(),
  isBuyBackQueue: Yup.boolean().nullable(),
  includedLenderIds: Yup.object().nullable(),
  includedPrimaryLeadSourceIds: Yup.object().nullable(),
  lenderIds: Yup.object().nullable(),
  hasReferralContactId: Yup.string().nullable(),
  isSpanish: Yup.boolean().nullable()
});

export const initialQueueConfiguration: IQueueConfiguration = {
  group: '',
  subgroup: '',
  paramsType: null,
  // menuWorkflows: {
  //   workflowIds: [],
  //   stepIds: [],
  // },
  menuWorkflows: [],
  isQueueEnabled: false,
  isCountRequired: false,
  isDownPaymentDeclineQueue: false,
  isBuyBackQueue: false,
  description: '',
  roleId: null,
  hasMyContacts: false,
  hasMyTeamContacts: false,
  hasMyDeals: false,
  hasMyTeamDeals: false,
  hasRedDeals: false,
  hasAmberDeals: false,
  hasGreenDeals: false,
  hasRedContacts: false,
  hasAmberContacts: false,
  hasGreenContacts: false,
  isUnAssigned: false,
  hasDeals: 'None',
  hasActiveDeal: 'True',
  unAssignedTag: null,
  isDealActive: 'None',
  assetSelected: 'True',
  isHotTitles: false,
  isAcceleratedTitleSupported: false,
  acceleratedTitleTitleIsReleasable: false,
  hasReferralContactId: 'None',
  excludedLenderIds: [],
  includedLenderIds: [],
  includedPrimaryLeadSourceIds:[],
  queueEmailRoles: [],
  lenderIds: [],
  isQueueEmailRequired: false,
  checkRequestStatus: null,
  isSpanish: false,
  checkCombineWorkflowStep: false
};

export const queueEmailRoles = [
  'LC',
  'LP',
  'Titles',
  'Accounting',
  'TeamDirector',
  'TeamManager',
  'TitlesManager',
  'TitlesLead',
  'Bank',
  'LCA',
  'SDR'
];

const unAssignedTypeList = [
  {
    label: 'Null',
    value: null,
  },
  {
    label: 'Accounting',
    value: 'Accounting',
  },
  {
    label: 'Bank',
    value: 'Bank',
  },
  {
    label: 'LP',
    value: 'LP',
  },
  {
    label: 'LC',
    value: 'LC',
  },
  {
    label: 'Titles',
    value: 'Titles',
  },
];

export const PARAMS_TYPES_OPTIONS = [
  {
    value: 'DealIndexParams',
    label: 'DealIndexParams',
  },
  {
    value: 'ContactIndexParams',
    label: 'ContactIndexParams',
  },
  {
    value: 'CheckQueue',
    label: 'CheckQueue',
  },
];

const checkQueueParamsList = ['checkRequestStatus'];

const contactIndexParamsList = [
  'hasMyDeals',
  'hasMyContacts',
  'hasMyTeamDeals',
  'hasMyTeamContacts',
  'hasRedDeals',
  'hasAmberDeals',
  'hasGreenDeals',
  'hasRedContacts',
  'hasAmberContacts',
  'hasGreenContacts',
  'isUnAssigned',
  'hasDeals',
  'hasActiveDeal',
  'hasReferralContactId',
  'isSpanish'
];

const dealIndexParamsList = [
  'hasMyDeals',
  'hasMyContacts',
  'hasMyTeamDeals',
  'hasMyTeamContacts',
  'hasRedDeals',
  'hasAmberDeals',
  'hasGreenDeals',
  'hasRedContacts',
  'hasAmberContacts',
  'hasGreenContacts',
  'isUnAssigned',
  'isDealActive',
  'assetSelected',
  'isHotTitles',
  'unAssignedTag',
  'isAcceleratedTitleSupported',
  'acceleratedTitleTitleIsReleasable'
];

export const configListByParamType = {
  DealIndexParams: dealIndexParamsList,
  ContactIndexParams: contactIndexParamsList,
  CheckQueue: checkQueueParamsList,
};

const booleanOptions = [
  {
    label: 'true',
    value: true,
  },
  {
    label: 'false',
    value: false,
  },
];

const CMLOptions = [
  {
    label: 'Null',
    value: null,
  },
  {
    label: 'None',
    value: 'None',
  },
  {
    label: 'True',
    value: 'True',
  },
  {
    label: 'False',
    value: 'False',
  },
];

export const checkRequestStatusList = [
  {
    label: 'Null',
    value: null,
  },
  {
    label: 'AddComment',
    value: 'AddComment',
  },
  {
    label: 'Submitted',
    value: 'Submitted',
  },
  {
    label: 'Approved',
    value: 'Approved',
  },
  {
    label: 'Declined',
    value: 'Declined',
  },
  {
    label: 'CheckCut',
    value: 'CheckCut',
  },
  {
    label: 'CheckVoid',
    value: 'CheckVoid',
  },
  {
    label: 'CheckProcessed',
    value: 'CheckProcessed',
  },
  {
    label: 'DownloadPdf',
    value: 'DownloadPdf',
  },
  {
    label: 'Sent',
    value: 'Sent',
  },
];

const getValueBool = (value: boolean | null) => Boolean(value);

export const allParamsList = [
  {
    name: 'hasMyDeals',
    title: 'My Deals',
    type: 'boolean',
    hideNoneOption: true,
    component: Select,
    value: getValueBool,
    options: booleanOptions,
  },
  {
    name: 'hasMyContacts',
    title: 'My Contacts',
    type: 'boolean',
    hideNoneOption: true,
    component: Select,
    value: getValueBool,
    options: booleanOptions,
  },
  {
    name: 'hasMyTeamDeals',
    title: 'My Team Deals',
    type: 'boolean',
    hideNoneOption: true,
    component: Select,
    options: booleanOptions,
  },
  {
    name: 'hasMyTeamContacts',
    title: 'My Team Contacts',
    type: 'boolean',
    hideNoneOption: true,
    component: Select,
    options: booleanOptions,
  },
  {
    name: 'hasRedDeals',
    title: 'Red Deals',
    type: 'boolean',
    hideNoneOption: true,
    component: Select,
    options: booleanOptions,
  },
  {
    name: 'hasAmberDeals',
    title: 'Amber Deals',
    type: 'boolean',
    hideNoneOption: true,
    component: Select,
    options: booleanOptions,
  },
  {
    name: 'hasGreenDeals',
    title: 'Green Deals',
    type: 'boolean',
    hideNoneOption: true,
    component: Select,
    options: booleanOptions,
  },
  {
    name: 'hasRedContacts',
    title: 'Red Contacts',
    type: 'boolean',
    hideNoneOption: true,
    component: Select,
    options: booleanOptions,
  },
  {
    name: 'hasAmberContacts',
    title: 'Amber Contacts',
    type: 'boolean',
    hideNoneOption: true,
    component: Select,
    options: booleanOptions,
  },
  {
    name: 'hasGreenContacts',
    title: 'Green Contacts',
    type: 'boolean',
    hideNoneOption: true,
    component: Select,
    options: booleanOptions,
  },
  {
    name: 'isUnAssigned',
    title: 'Unassigned',
    type: 'boolean',
    hideNoneOption: true,
    component: Select,
    options: booleanOptions,
  },
  {
    name: 'unAssignedTag',
    title: 'Unassigned Tag',
    type: 'CML',
    component: Select,
    options: unAssignedTypeList,
    hideNoneOption: true,
  },
  {
    name: 'isDealActive',
    title: 'Is Active',
    type: 'CML',
    options: CMLOptions,
    component: Select,
    hideNoneOption: true,
  },
  {
    name: 'assetSelected',
    title: 'Asset Selected',
    type: 'CML',
    options: CMLOptions,
    component: Select,
    hideNoneOption: true,
  },
  {
    name: 'isHotTitles',
    title: 'Is Hot Titles',
    type: 'boolean',
    component: Select,
    options: booleanOptions,
    hideNoneOption: true,
  },
  {
    name: 'isAcceleratedTitleSupported',
    title: 'Is Accelerated Title Supported',
    type: 'boolean',
    component: Select,
    options: booleanOptions,
    hideNoneOption: true,
  },
  {
    name: 'acceleratedTitleTitleIsReleasable',
    title: 'Accelerated Title Title Is Releasable',
    type: 'boolean',
    component: Select,
    options: booleanOptions,
    hideNoneOption: true,
  },
  {
    name: 'isSpanish',
    title: 'Is Spanish',
    type: 'boolean',
    component: Select,
    options: booleanOptions,
    hideNoneOption: true,
  },
  {
    name: 'hasDeals',
    title: 'Has Deals',
    type: 'CML',
    options: CMLOptions,
    component: Select,
    hideNoneOption: true,
  },
  {
    name: 'hasActiveDeal',
    title: 'Has Active Deals',
    type: 'CML',
    options: CMLOptions,
    component: Select,
    hideNoneOption: true,
  },
  {
    name: 'hasReferralContactId',
    title: 'Has Referral Contact Id',
    type: 'CML',
    options: CMLOptions,
    component: Select,
    hideNoneOption: true,
  },
  {
    name: 'checkRequestStatus',
    title: 'Check Request Status',
    type: 'CML',
    component: Select,
    options: checkRequestStatusList,
    hideNoneOption: true,
  },
];

